import { NgModule } from '@angular/core';
import { PrimengModule } from '@modules/primeng.module';

import { BrowserModule } from '@angular/platform-browser';
import { AppRoutingModule } from '@routingModule';
import { SharedModule } from '../../../shared/shared.module';
import { MaterialModule } from '@modules/material.module';
import { TableModule } from 'primeng/table';
import { HistoricoConciliacaoComponent } from './components/historico-conciliacao.component';
import { HistoricoConciliacaoApiService } from './services/historico-conciliacao-api.service';
import { HistoricoConciliacaoResolver } from './historico-conciliacao.resolver';
import { ReconciliarLancamentosDialogComponent } from './components/reconciliar-lancamentos-dialog/reconciliar-lancamentos-dialog.component';
import { EscolherLoteImportacaoDialogComponent } from './components/escolher-lote-importacao-dialog/escolher-lote-importacao-dialog.component';
import { DesfazerImportacaoDialogComponent } from './components/desfazer-importacao-dialog/desfazer-importacao-dialog.component';



@NgModule({
  declarations: [
    HistoricoConciliacaoComponent,
    ReconciliarLancamentosDialogComponent,
    EscolherLoteImportacaoDialogComponent,
    DesfazerImportacaoDialogComponent,
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    SharedModule,
    MaterialModule,
    TableModule,
    PrimengModule,
  ],
  providers: [
    { provide: HistoricoConciliacaoApiService, useClass: HistoricoConciliacaoApiService },
    HistoricoConciliacaoResolver
  ],
})
export class HistoricoConciliacaoModule { }
